import api from "@/lib/api";

export default {
  namespaced: true,
  state: {
    list: [],
    loading: true,
    posting: false,
    isAddOrEdit: false,
    statusing: false,
    category: {
      id: 0,
      name: "",
      order: 0,
      status: true
    }
  },
  mutations: {
    SET_CATEGORY(state, category) {
      state.category = category;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_POSTING(state, payload) {
      state.posting = payload;
    },
    SET_STATUSING(state, payload) {
      state.statusing = payload;
    },
    SET_CATEGORIES(state, categories) {
      state.list = categories;
    },
    SET_IS_ADD_OR_EDIT(state, payload) {
      if (!payload)
        state.category = {
          id: 0,
          name: "",
          status: true
        };
      state.isAddOrEdit = payload;
    },
    RESET_CATEGORY(state) {
      state.category = {
        id: 0,
        name: "",
        status: true
      };
    }
  },
  actions: {
    setLoading({ commit }, payload) {
      commit("SET_LOADING", payload);
    },
    setIsAddOrEdit({ commit }, payload) {
      if (!payload) commit("RESET_CATEGORY");
      commit("SET_IS_ADD_OR_EDIT", payload);
    },
    async getCategoryById({}, id) {
      const response = await api.get(`/categories/${id}`);
      return response.data;
    },
    async editCategory({ dispatch, commit }, id) {
      commit("SET_CATEGORY", await dispatch("getCategoryById", id));
      commit("SET_IS_ADD_OR_EDIT", true);
    },
    async toggleStatus({ dispatch, commit }, category) {
      commit("SET_STATUSING", true);
      await api.patch(`/categories/${category.id}`, {
        status: !category.status
      });
      dispatch("getCategories", { bypass: true });
    },
    async deleteCategory({ dispatch }, id) {
      await api.delete(`/categories/${id}`);
      dispatch("getCategories");
    },
    async saveCategory({ commit, dispatch }, category) {
      commit("SET_POSTING", true);
      try {
        if (category.id) {
          await api.put(`/categories/${category.id}`, category);
        } else {
          await api.post("/categories", category);
        }
        dispatch("getCategories");
        commit("SET_IS_ADD_OR_EDIT", false);
        commit("SET_POSTING", false);
        commit("RESET_CATEGORY");
      } catch (error) {
        commit("SET_POSTING", false);
      }
    },
    async getCategories({ commit }, { bypass = false } = {}) {
      if (!bypass) commit("SET_LOADING", true);
      const response = await api.get("/categories");
      response.data.sort((a, b) => a.order - b.order);
      commit("SET_CATEGORIES", response.data);
      if (!bypass) commit("SET_LOADING", false);
      commit("SET_STATUSING", false);
    },
    async updateOrder({ dispatch }, category) {
      if (category.order != 0) {
        await api.put(`/categories/${category.id}`, category);
        dispatch("getCategories", { bypass: true });
      }
    }
  },
  getters: {
    categories: state => state.list
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/category.js